import React from "react";
import { FaWhatsapp } from "react-icons/fa";

import { COMPANY } from "config/constants/Company";

/**
 * Botón flotante de contacto por WhatsApp, siempre visible (abajo a la derecha, también en el login).
 * En computadora ofrece WhatsApp Web; en el celular abre la app.
 */
const WhatsAppButton = () => (
  <a
    href={COMPANY.WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    title="Contactanos por WhatsApp"
    aria-label="Contactanos por WhatsApp"
    className="fixed bottom-5 right-5 z-[45] flex items-center justify-center h-12 w-12 rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 hover:bg-[#1EBE5A] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 dark:focus:ring-offset-gray-900"
  >
    <FaWhatsapp size={26} />
  </a>
);

export default WhatsAppButton;
